import firebaseErrors from '@/assets/errors/firebase.json'
import internalErrors from '@/assets/errors/internal.json'
import mapsErrors from '@/assets/errors/maps.json'

export default ({ store }, inject) => {
  inject('notifier', {
    showMessage({ content = '', color = 'info', prependIcon = null }) {
      let errorTranslations = Object.assign(
        {},
        firebaseErrors,
        internalErrors,
        mapsErrors
      )
      let msg = errorTranslations[content] || content
      store.commit('snackbar/showMessage', {
        content: msg,
        prependIcon: prependIcon,
        color: color
      })
    }
  })
}
